import type { Role } from '@/types';

/** Internal all-customers view (ADR-0001). Story 110112 grants Super Admin, Admin and Operational
 *  Associate; Field Installer is denied (and Dealer, whose scoped portal view is a later story). */
export const CUSTOMERS_ROLES: Role[] = ['super_admin', 'admin', 'operational_associate'];

/** Human page name surfaced in the access-denied toast (ADR-0014). Story 110112 words the message
 *  "…permission to access Customer Management", so the page name is not simply "Customers". */
export const CUSTOMERS_PAGE_NAME = 'Customer Management';
